import { TableColumn } from '../../views/table/Table'
import { OrderItem } from '../../../utils/http/Services/project'
import styled from 'styled-components'
import { XImage } from '../../views/common/XImage'
import { Images } from '../../../utils/images'
import { formatSat, getErrorMsg } from '../../../utils'
import { commonStyles } from '../../../utils/commonStyles'
import Image from 'next/image'
import Loading from '../../views/common/Loading'
import { CardSize, OrderStatus } from '../../../utils/type'
import AddressLink from '../../views/common/AddressLink'
import moment from 'moment'
import { XButton } from '../../views/common/XButton'
import { useWallet } from '../../context/WalletContext'
import { useModal } from '../../context/ModalContext'
import { BuyModal } from '../../views/modal/BuyModal'
import { useFilterContext } from './FilterContext'
import { DialogType, useDialog } from '../../context/DialogContext'
import InscriptionCard from '../../views/common/InscriptionCard'

export const columns: TableColumn<OrderItem>[] = [
  {
    name: 'Item',
    align: 'left',
    width: '30%',
    headStyle: {
      paddingLeft: 30,
    },
    itemStyle: {
      paddingLeft: 30,
    },
    render: (data) => (
      <>
        <InscriptionCard style={{ marginRight: 9 }} content={data} size={CardSize.Small} />
        <Name>{data.name}</Name>
        {data.order_status === OrderStatus.Pending && <StyledLoading />}
      </>
    ),
  },
  // {
  //   name: 'Rarity',
  //   render: () => <>3844</>,
  // },
  {
    name: 'Price',
    align: 'left',
    render: (data) => (
      <InfoPrice>
        <BtcIcon />
        {formatSat(data.price)} BTC
      </InfoPrice>
    ),
  },
  {
    name: 'Last Sale',
    align: 'left',
    render: (data) => (
      <InfoPrice>
        <BtcIcon />
        {formatSat(data.last_sale_price)} BTC
      </InfoPrice>
    ),
  },
  {
    name: 'Owner',
    align: 'left',
    render: (data) => <AddressLink style={{ color: '#FFF' }} addr={data.owner} shorten={10} />,
  },
  {
    name: 'Listed',
    align: 'left',
    render: (data) => <ListedTime>{data.listing_time > 0 ? moment.unix(data.listing_time).fromNow() : '-'}</ListedTime>,
  },
  {
    name: '',
    align: 'left',
    render: (data) => <Buy data={data} />,
  },
]

function Buy(props: { data: OrderItem }) {
  const { account } = useWallet()
  const isOwner = account === props.data.owner
  const isPending = props.data.order_status === OrderStatus.Pending
  const isListed = props.data.order_id !== 0
  const canBuy = !isOwner && !isPending && isListed
  const { onBuyed } = useFilterContext()
  const { openModal } = useModal()
  const { openDialog } = useDialog()

  return (
    <BuyButton
      disabled={!canBuy}
      onClick={async (e) => {
        e.stopPropagation()
        e.preventDefault()
        try {
          const result = await openModal(BuyModal, { id: props.data.inscription_id })
          if (result) {
            onBuyed(props.data.inscription_id)
          }
        } catch (e) {
          openDialog(DialogType.Error, { title: 'error', desc: getErrorMsg(e) })
        }
      }}
    >
      <BuyIcon />
      Buy
    </BuyButton>
  )
}

const ImageIcon = styled(XImage)`
  width: 30px;
  height: 30px;
  margin-right: 9px;
`
const Name = styled.span`
  font-size: 14px;
  line-height: 14px;
  color: #efefef;
`

const InfoTitle = styled.h3`
  font-size: 16px;
  color: #efefef;
  line-height: 16px;
  :hover > & {
    color: #9e9e9e;
  }
`

const ListedTime = styled.span`
  color: #efefef;
`

const InfoPrice = styled(InfoTitle)`
  margin-top: 15px;
  ${commonStyles.flexStart};
  //padding-left: 17px;
`

const BtcIcon = styled(Image).attrs({
  src: Images.COMMON.LOGO_BTC_SVG,
  width: 15,
  height: 15,
  alt: 'btc',
})`
  width: 15px;
  height: 15px;
  margin-right: 6px;
`

const StyledLoading = styled(Loading).attrs({
  size: 20,
})`
  position: absolute;
  left: 0px;
  top: 5px;
`

const BuyButton = styled(XButton)`
  width: 117px;
  height: 37px;
`

const BuyIcon = styled(XImage).attrs({
  src: Images.COMMON.ICON_BUY_SVG,
})`
  width: 8px;
  height: 15px;
  margin-right: 11px;
`
